import api from "../../axios/api.js";

export class TokenService {
  async postTokenGet(body) {
    const data = await api.post("Token/get/", body);
    return data;
  }
}
